import Image from 'components/Image';
import { ImageProps } from 'next/image';
import styled from 'styled-components';

interface ImageContainerProps extends ImageProps {
    $active: boolean;
}

const Photo = styled(Image)<ImageContainerProps>`
    ${({ $active, theme }) => $active && `border: 2px solid ${theme.colors.primary}!important`};
    :hover {
        cursor: pointer;
    }
`;

export default Photo;
